/* Barlen: de bezorgdag voor kleden op voorraad.
   Rekent altijd met de klok van Amsterdam, ook als het apparaat in een andere tijdzone staat, en bij elke weergave
   opnieuw, dus een pagina uit een cache toont nooit een verouderde dag. Een dag is een hele kalenderdag (een dagnummer
   telt de dagen sinds het begin van de Unix-tijd), zodat zomer- en wintertijd niets verschuiven. Weekdagen: 1 = maandag
   tot en met 7 = zondag. Op een feestdag of een gesloten dag wordt niet ingepland, niet verzonden en niet bezorgd.
   De instellingen staan in het blok #barlen-bezorgdag. Geen afhankelijkheden. */
(function () {
  'use strict';
  if (window.BarlenBezorgdag) return;

  var DAG_MS = 86400000;
  var STANDAARD = {
    tijdzone: 'Europe/Amsterdam',
    besteltijd: '16:00',
    plandagen: [1, 2, 3, 4, 5],
    plannenOpGesloten: false,
    verzenddagen: [2, 5],
    dagenOnderweg: 1,
    bezorgdagen: [2, 3, 4, 5, 6],
    goedeVrijdag: false,
    bevrijdingsdag: false,
    gesloten: [],
    vensterDagen: 90
  };

  /* ---------- kalenderdagen */
  function dagNummer(j, m, d) { return Math.floor(Date.UTC(j, m - 1, d) / DAG_MS); }
  function datumVan(dag) { var x = new Date(dag * DAG_MS); return { j: x.getUTCFullYear(), m: x.getUTCMonth() + 1, d: x.getUTCDate() }; }
  function weekdag(dag) { return ((((dag + 3) % 7) + 7) % 7) + 1; }
  function twee(n) { return String(n).padStart(2, '0'); }
  function isoVan(dag) { var x = datumVan(dag); return x.j + '-' + twee(x.m) + '-' + twee(x.d); }
  function dagVanIso(tekst) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(tekst || ''));
    if (!m) return null;
    var dag = dagNummer(+m[1], +m[2], +m[3]);
    return isoVan(dag) === tekst ? dag : null;
  }

  /* ---------- de klok van de winkel */
  var opmaak = {};
  function onderdelen(ms, tz) {
    var f = opmaak[tz];
    if (!f) {
      f = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' });
      opmaak[tz] = f;
    }
    var p = {};
    f.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    return p;
  }
  function wandklok(ms, tz) {
    var p = onderdelen(ms, tz || STANDAARD.tijdzone);
    var uur = Number(p.hour) % 24, minuut = Number(p.minute);
    var dag = dagNummer(Number(p.year), Number(p.month), Number(p.day));
    return { dag: dag, minuten: uur * 60 + minuut, iso: isoVan(dag), tijd: twee(uur) + ':' + twee(minuut), weekdag: weekdag(dag) };
  }
  function momentVan(dag, minuten, tz) {
    var ms = dag * DAG_MS + minuten * 60000;
    for (var i = 0; i < 4; i++) {
      var w = wandklok(ms, tz);
      var verschil = (w.dag - dag) * 1440 + (w.minuten - minuten);
      if (verschil === 0) break;
      ms -= verschil * 60000;
    }
    return ms;
  }
  /* Verschil tussen het apparaat en de server, uit de kop Date van een antwoord van de eigen winkel. Binnen de marge
     geldt de klok van het apparaat. */
  function klokverschil(apparaatMs, datumKop, marge) {
    var server = Date.parse(String(datumKop || ''));
    if (!isFinite(server)) return 0;
    var verschil = server - apparaatMs;
    return Math.abs(verschil) > (marge == null ? 120000 : marge) ? verschil : 0;
  }

  /* ---------- feestdagen */
  function pasen(j) {
    var a = j % 19, b = Math.floor(j / 100), c = j % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    return dagNummer(j, Math.floor((h + l - 7 * m + 114) / 31), ((h + l - 7 * m + 114) % 31) + 1);
  }
  var feestCache = {};
  function feestdagen(j, s) {
    var sleutel = j + ':' + s.goedeVrijdag + ':' + s.bevrijdingsdag;
    if (feestCache[sleutel]) return feestCache[sleutel];
    var p = pasen(j);
    var koningsdag = dagNummer(j, 4, 27);
    if (weekdag(koningsdag) === 7) koningsdag -= 1;
    var lijst = {};
    lijst[dagNummer(j, 1, 1)] = 'Nieuwjaarsdag';
    lijst[p] = 'Eerste paasdag';
    lijst[p + 1] = 'Tweede paasdag';
    lijst[koningsdag] = 'Koningsdag';
    lijst[p + 39] = 'Hemelvaartsdag';
    lijst[p + 49] = 'Eerste pinksterdag';
    lijst[p + 50] = 'Tweede pinksterdag';
    lijst[dagNummer(j, 12, 25)] = 'Eerste kerstdag';
    lijst[dagNummer(j, 12, 26)] = 'Tweede kerstdag';
    if (s.goedeVrijdag) lijst[p - 2] = 'Goede Vrijdag';
    if (s.bevrijdingsdag && !lijst[dagNummer(j, 5, 5)]) lijst[dagNummer(j, 5, 5)] = 'Bevrijdingsdag';
    feestCache[sleutel] = lijst;
    return lijst;
  }
  function geslotenOp(dag, s) {
    if (s.gesloten[dag]) return 'gesloten';
    return feestdagen(datumVan(dag).j, s)[dag] || null;
  }

  /* ---------- schema */
  function maakSchema(eigen) {
    var s = {};
    Object.keys(STANDAARD).forEach(function (k) { s[k] = STANDAARD[k]; });
    Object.keys(eigen || {}).forEach(function (k) { if (eigen[k] != null) s[k] = eigen[k]; });
    var t = /^(\d{1,2}):(\d{2})$/.exec(String(s.besteltijd));
    if (!t || +t[1] > 23 || +t[2] > 59) t = ['16:00', '16', '00'];
    var gesloten = {};
    (Array.isArray(s.gesloten) ? s.gesloten : []).forEach(function (iso) {
      var dag = dagVanIso(String(iso).trim().slice(0, 10));
      if (dag !== null) gesloten[dag] = true;
    });
    var venster = Math.trunc(Number(s.vensterDagen));
    return {
      tijdzone: s.tijdzone,
      besteltijd: twee(+t[1]) + ':' + t[2],
      besteltijdMinuten: +t[1] * 60 + +t[2],
      plandagen: s.plandagen,
      plannenOpGesloten: !!s.plannenOpGesloten,
      verzenddagen: s.verzenddagen,
      bezorgdagen: s.bezorgdagen,
      dagenOnderweg: Math.max(0, Math.trunc(Number(s.dagenOnderweg) || 0)),
      goedeVrijdag: !!s.goedeVrijdag,
      bevrijdingsdag: !!s.bevrijdingsdag,
      gesloten: gesloten,
      vensterDagen: venster >= 1 ? venster : 90
    };
  }

  /* ---------- rekenen */
  function isPlandag(dag, s) { return s.plandagen.indexOf(weekdag(dag)) > -1 && (s.plannenOpGesloten || !geslotenOp(dag, s)); }
  function isVerzenddag(dag, s) { return s.verzenddagen.indexOf(weekdag(dag)) > -1 && !geslotenOp(dag, s); }
  function isBezorgdag(dag, s) { return s.bezorgdagen.indexOf(weekdag(dag)) > -1 && !geslotenOp(dag, s); }
  function eerste(vanaf, test, s) {
    for (var d = vanaf; d < vanaf + 400; d++) if (test(d, s)) return d;
    throw new Error('Geen geschikte dag binnen 400 dagen.');
  }
  function rekenVanaf(dag, minuten, s) {
    var plandag = isPlandag(dag, s) && minuten < s.besteltijdMinuten ? dag : eerste(dag + 1, isPlandag, s);
    var vertrekdag = eerste(plandag + 1, isVerzenddag, s);
    var bezorgdag = eerste(vertrekdag + s.dagenOnderweg, isBezorgdag, s);
    return { plandag: plandag, vertrekdag: vertrekdag, bezorgdag: bezorgdag };
  }
  /* De eerst mogelijke dag op een moment, en wanneer die voor het eerst verandert (alleen op de besteltijd of om
     middernacht). aftellen.toon is alleen waar als de dag vandaag nog verandert. */
  function bezorging(ms, s) {
    var nu = wandklok(ms, s.tijdzone);
    var r = rekenVanaf(nu.dag, nu.minuten, s);
    var omslag = null;
    for (var k = 0; k <= 31 && !omslag; k++) {
      var dag = nu.dag + k;
      var kandidaten = [];
      if (k > 0) kandidaten.push(0);
      if (k > 0 || nu.minuten < s.besteltijdMinuten) kandidaten.push(s.besteltijdMinuten);
      for (var i = 0; i < kandidaten.length; i++) {
        var ander = rekenVanaf(dag, kandidaten[i], s);
        if (ander.bezorgdag !== r.bezorgdag) {
          omslag = { dag: dag, minuten: kandidaten[i], ms: momentVan(dag, kandidaten[i], s.tijdzone), bezorgdag: ander.bezorgdag };
          break;
        }
      }
    }
    var vandaag = !!omslag && omslag.dag === nu.dag;
    return { nu: nu, plandag: r.plandag, vertrekdag: r.vertrekdag, bezorgdag: r.bezorgdag, omslag: omslag, aftellen: { toon: vandaag, ms: vandaag ? Math.max(0, omslag.ms - ms) : null } };
  }
  /* Alle bezorgdagen van de eerst mogelijke tot en met vandaag plus het aantal dagen van het venster. */
  function dagenInVenster(ms, s) {
    var nu = wandklok(ms, s.tijdzone);
    var bezorgdag = rekenVanaf(nu.dag, nu.minuten, s).bezorgdag;
    var uit = [];
    for (var d = bezorgdag; d <= nu.dag + s.vensterDagen; d++) if (isBezorgdag(d, s)) uit.push(d);
    if (!uit.length) uit.push(bezorgdag);
    return uit;
  }

  /* ---------- winkelwagen */
  /* Een regel krijgt een dag als het een standaardkleed is met bijgehouden voorraad die het aantal dekt. */
  function regelOpVoorraad(r) {
    return !!r && !r.maatwerk && r.beschikbaar !== false && !!r.beheer && Number(r.voorraad) >= Math.max(1, Number(r.aantal) || 1);
  }
  /* Een levertijd uit tekst, in weken, dagen of werkdagen, met of zonder bereik ("16 tot 18 weken"). */
  function levertijdUitTekst(tekst) {
    var t = String(tekst || '').toLowerCase().replace(/ /g, ' ');
    var m = /(\d+)\s*(?:(?:tot|à|-|–|—)\s*(\d+)\s*)?(werkdagen|werkdag|weken|week|dagen|dag)\b/.exec(t);
    if (!m) return null;
    var min = Number(m[1]), max = Number(m[2] || m[1]);
    if (!(min > 0) || max < min) return null;
    var eenheid = m[3].indexOf('werkdag') === 0 ? 'werkdagen' : m[3].indexOf('we') === 0 ? 'weken' : 'dagen';
    return { min: min, max: max, eenheid: eenheid };
  }
  function naLevertijd(dag, aantal, eenheid, s) {
    if (eenheid === 'weken') return dag + 7 * aantal;
    if (eenheid === 'dagen') return dag + aantal;
    var d = dag, n = 0;
    while (n < aantal) { d++; if (weekdag(d) <= 5 && !geslotenOp(d, s)) n++; }
    return d;
  }
  /* Een kleed op voorraad met een kleed dat nog gemaakt wordt: de eerste dag waarop alles samen kan, of null als een
     levertijd niet te lezen is. */
  function samenVanaf(ms, levertijden, s) {
    var nu = wandklok(ms, s.tijdzone);
    var snel = rekenVanaf(nu.dag, nu.minuten, s).bezorgdag;
    if (!levertijden.length) return null;
    var tot = -Infinity;
    for (var i = 0; i < levertijden.length; i++) {
      var lt = levertijdUitTekst(levertijden[i]);
      if (!lt) return null;
      tot = Math.max(tot, naLevertijd(nu.dag, lt.max, lt.eenheid, s));
    }
    return eerste(Math.max(tot, snel), isBezorgdag, s);
  }

  /* ---------- tekst */
  var DAGEN = ['maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag', 'zondag'];
  var DAGEN_KORT = ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo'];
  var MAANDEN = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
  var MAANDEN_KORT = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  /* Vormen: 'lang' (weekdag, dag en maand), 'kort' (afgekort), 'met-jaar' (met het jaar erachter), 'dag' (alleen de
     weekdag) en 'dagmaand' (dag en maand). */
  function datumTekst(dag, vorm) {
    var x = datumVan(dag), w = weekdag(dag) - 1;
    if (vorm === 'kort') return DAGEN_KORT[w] + ' ' + x.d + ' ' + MAANDEN_KORT[x.m - 1];
    if (vorm === 'met-jaar') return DAGEN[w] + ' ' + x.d + ' ' + MAANDEN[x.m - 1] + ' ' + x.j;
    if (vorm === 'dag') return DAGEN[w];
    if (vorm === 'dagmaand') return x.d + ' ' + MAANDEN[x.m - 1];
    return DAGEN[w] + ' ' + x.d + ' ' + MAANDEN[x.m - 1];
  }
  function hoofdletter(t) { return t.charAt(0).toUpperCase() + t.slice(1); }
  /* Resterende tijd, naar beneden afgerond op hele minuten. */
  function duurTekst(ms) {
    var totaal = Math.floor(Math.max(0, ms) / 60000);
    if (totaal < 1) return 'minder dan een minuut';
    var u = Math.floor(totaal / 60), r = totaal % 60;
    var uren = u ? u + ' uur' : '';
    var minuten = r ? r + (r === 1 ? ' minuut' : ' minuten') : '';
    return uren && minuten ? uren + ' en ' + minuten : uren || minuten;
  }

  /* ---------- de werkwijze in de winkel: kenmerken en controle */
  function vkDatum(dag) { var x = datumVan(dag); return twee(x.d) + '-' + twee(x.m) + '-' + x.j; }
  function vkDag(dag) { return hoofdletter(datumTekst(dag, 'dag')); }
  function leesVkDatum(tekst) {
    var m = /^(\d{2})-(\d{2})-(\d{4})$/.exec(String(tekst || ''));
    return m ? dagVanIso(m[3] + '-' + m[2] + '-' + m[1]) : null;
  }
  function kiesbaar(ms, s) { return dagenInVenster(ms, s); }
  function geldig(dag, ms, s) { return typeof dag === 'number' && isFinite(dag) && kiesbaar(ms, s).indexOf(dag) > -1; }
  function belofte(ms, s, opties) {
    var b = bezorging(ms, s);
    var tel = !!(opties && opties.afteller) && b.aftellen.toon;
    return { dag: b.bezorgdag, hoofd: 'Gratis bezorgd vanaf ' + datumTekst(b.bezorgdag), bij: tel ? 'bestel binnen ' + duurTekst(b.aftellen.ms) : 'kies je gewenste bezorgdag', afteller: tel };
  }
  function belofteVoor(variant, ms, s, opties) { return regelOpVoorraad(variant) ? belofte(ms, s, opties) : null; }
  /* De kenmerken voor de bestelling. Alleen voorraad: Bezorgdatum en Bezorgdag. Met een kleed dat nog gemaakt wordt
     ook Bezorging: "In twee keer" of "Alles samen" (dan zonder dag). */
  function vkKenmerken(k) {
    k = k || {};
    if (k.gemengd && k.samen) return { Bezorgdatum: '', Bezorgdag: '', Bezorging: 'Alles samen' };
    var uit = {};
    if (typeof k.dag === 'number' && isFinite(k.dag)) { uit.Bezorgdatum = vkDatum(k.dag); uit.Bezorgdag = vkDag(k.dag); }
    if (k.gemengd) uit.Bezorging = 'In twee keer';
    return uit;
  }
  function magAfrekenen(k, ms, s) {
    k = k || {};
    if (k.gemengd && k.samen) return { mag: true, reden: null, melding: '' };
    if (typeof k.dag !== 'number' || !isFinite(k.dag)) return { mag: false, reden: 'geen dag', melding: 'Kies eerst je gewenste bezorgdag.' };
    if (!geldig(k.dag, ms, s)) return { mag: false, reden: 'verlopen', melding: hoofdletter(datumTekst(k.dag)) + ' kan niet meer. Kies een nieuwe dag.' };
    return { mag: true, reden: null, melding: '' };
  }

  /* ---------- instellingen van het thema en de klok van de server */
  function instellingen() {
    var el = document.getElementById('barlen-bezorgdag');
    var uit = { aan: false, besteltijd: '16:00', venster: 90, samen: false, afteller: false, gesloten: [], wagen: '/cart' };
    if (!el) return uit;
    try {
      var j = JSON.parse(el.textContent);
      Object.keys(j).forEach(function (k) { uit[k] = j[k]; });
    } catch (e) { uit.aan = false; }
    return uit;
  }
  var inst = instellingen();
  var schema = maakSchema({ besteltijd: inst.besteltijd, vensterDagen: inst.venster, gesloten: inst.gesloten });

  var verschil = 0;
  var klokBelofte = null;
  var KLOK = 'bz-klok';
  function nu() { return Date.now() + verschil; }
  function klok() {
    if (klokBelofte) return klokBelofte;
    try {
      var b = JSON.parse(sessionStorage.getItem(KLOK) || 'null');
      if (b && typeof b.verschil === 'number' && b.tot > Date.now()) { verschil = b.verschil; klokBelofte = Promise.resolve(verschil); return klokBelofte; }
    } catch (e) { /* zonder opslag: opnieuw meten */ }
    klokBelofte = fetch(String(inst.wagen || '/cart').replace(/\/$/, '') + '.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) {
        verschil = klokverschil(Date.now(), r.headers.get('date'));
        try { sessionStorage.setItem(KLOK, JSON.stringify({ verschil: verschil, tot: Date.now() + 1800000 })); } catch (e) { /* niets */ }
        return verschil;
      })
      .catch(function () { return 0; });
    return klokBelofte;
  }

  /* ---------- de regel onder de koopknop: [data-bz-belofte] met data-voorraad="1" bij een maat op voorraad */
  function esc(t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tekenBelofte(el) {
    var tekst = el.querySelector('[data-bz-belofte-tekst]');
    if (!tekst) return;
    var b = inst.aan && el.getAttribute('data-voorraad') === '1' ? belofte(nu(), schema, { afteller: !!inst.afteller }) : null;
    var html = b ? '<strong>' + esc(b.hoofd) + '</strong> <span class="bz-zacht">· ' + esc(b.bij) + '</span>' : esc(el.getAttribute('data-standaard') || '');
    if (tekst.innerHTML !== html) tekst.innerHTML = html;
  }
  function allebeloftes() { Array.prototype.forEach.call(document.querySelectorAll('[data-bz-belofte]'), tekenBelofte); }
  var gevolgd = typeof WeakSet === 'function' ? new WeakSet() : null;
  function volg() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bz-belofte]'), function (el) {
      if (gevolgd && gevolgd.has(el)) return;
      if (gevolgd) gevolgd.add(el);
      new MutationObserver(function () { tekenBelofte(el); }).observe(el, { attributes: true, attributeFilter: ['data-voorraad'] });
      tekenBelofte(el);
      if (inst.aan && el.getAttribute('data-voorraad') === '1') klok().then(allebeloftes);
    });
  }
  function start() {
    volg();
    if (inst.aan) {
      setInterval(function () { if (!document.hidden) allebeloftes(); }, 30000);
      document.addEventListener('visibilitychange', function () { if (!document.hidden) allebeloftes(); });
    }
    document.addEventListener('shopify:section:load', volg);
  }

  window.BarlenBezorgdag = {
    STANDAARD: STANDAARD,
    dagNummer: dagNummer, datumVan: datumVan, weekdag: weekdag, isoVan: isoVan, dagVanIso: dagVanIso,
    wandklok: wandklok, momentVan: momentVan, klokverschil: klokverschil,
    pasen: pasen, feestdagen: feestdagen, geslotenOp: geslotenOp, maakSchema: maakSchema,
    isBezorgdag: isBezorgdag, rekenVanaf: rekenVanaf, bezorging: bezorging, dagenInVenster: dagenInVenster,
    regelOpVoorraad: regelOpVoorraad, levertijdUitTekst: levertijdUitTekst, naLevertijd: naLevertijd, samenVanaf: samenVanaf,
    datumTekst: datumTekst, hoofdletter: hoofdletter, duurTekst: duurTekst,
    vkDatum: vkDatum, vkDag: vkDag, leesVkDatum: leesVkDatum, kiesbaar: kiesbaar, geldig: geldig,
    belofte: belofte, belofteVoor: belofteVoor, vkKenmerken: vkKenmerken, magAfrekenen: magAfrekenen,
    instellingen: inst, schema: schema, nu: nu, klok: klok, tekenBeloftes: allebeloftes
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
